export default (validatorResult, message, severity = 'danger') => ({
  hasPassedValidator: validatorResult,
  hasNoError: validatorResult || severity !== 'danger',
  hasError: !validatorResult && severity === 'danger',
  hasNoWarning: validatorResult || severity !== 'warn',
  hasWarning: !validatorResult && severity === 'warn',
  ...(!validatorResult && {
    message: message[severity] || message,
    severity,
  }),
});
